var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGearSolidWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 482.6 511.9",
    style: {
      enableBackground: "new 0 0 482.6 511.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M481.2,166.6c3.1,8.7,0.6,18.5-6.4,24.6l-43.3,39.4c2.3,16.9,2.3,33.9,0,50.8l43.3,39.4 c7,6.1,9.5,15.9,6.4,24.6c-4.4,11.8-9.7,23.3-15.8,34.3l-4.7,8.1c-6.6,10.9-14,21.4-22.1,31.2c-5.9,7.2-15.7,9.6-24.5,6.8 l-55.7-17.7c-13.5,10.4-28.3,18.9-44,25.4l-12.5,57.1c-1.8,9.1-9.1,16.2-18.2,17.8c-28.1,4.7-56.9,4.7-85,0 c-9.1-1.6-16.4-8.7-18.2-17.8L168,433.5c-15.7-6.5-30.5-15-44-25.4l-55.6,17.8c-8.8,2.9-18.5,0.2-24.5-6.8 c-8.1-9.8-15.5-20.3-22.1-31.2l-4.7-8.1c-6.1-11-11.4-22.5-15.8-34.3c-3.1-8.7-0.6-18.5,6.4-24.6L51,281.5c-1.1-8.5-1.7-17-1.7-25.5 c0-8.5,0.6-17,1.7-25.4L7.7,191.2c-7-6.1-9.5-15.9-6.4-24.6c4.4-11.8,9.7-23.3,15.8-34.3l4.7-8.1c6.6-10.9,14-21.4,22.1-31.2 c5.9-7.2,15.7-9.6,24.5-6.8l55.7,17.7c13.5-10.4,28.3-18.9,44-25.4l12.5-57.1c1.8-9.1,9.1-16.2,18.2-17.8c14-2.4,28.3-3.6,42.5-3.6 c14.2,0,28.5,1.2,42.5,3.5c9.1,1.6,16.4,8.7,18.2,17.8l12.5,57.1c15.7,6.5,30.5,15,44,25.4l55.7-17.7c8.8-2.9,18.5-0.2,24.5,6.8 c8.1,9.8,15.5,20.3,22.1,31.2l4.7,8.1c6.1,11,11.4,22.5,15.8,34.3L481.2,166.6z M241.3,336c44.2,0,80-35.8,80-80s-35.8-80-80-80 s-80,35.8-80,80S197.2,336,241.3,336z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGearSolidWhite);
export default __webpack_public_path__ + "static/media/gear-solid-white.7642cd557a0ca3a07bf20fe3df421224.svg";
export { ForwardRef as ReactComponent };